import {
  BASE_URL_WEB_APP_DEV,
  BASE_URL_WEB_APP_PROD,
  GO_LINK_ADJ_T,
} from '@/app/main/split-bills/constants';
import {isProduction} from '@/utils/environment';

import {buildAdjustLink} from './buildAdjustLink';

const COMMON_ROOT_ROUTE = 'SPLIT_BILLS_DASHBOARD';

export const buildSplitGroupInviteLink = (
  groupId: string,
  inviterName?: string,
): string => {
  const path = `${COMMON_ROOT_ROUTE}/${groupId}${
    inviterName ? `/${inviterName}` : ''
  }`;

  const fallbackParams = new URLSearchParams({groupId});
  if (inviterName) {
    fallbackParams.set('inviterName', inviterName);
  }
  const baseUrl = isProduction ? BASE_URL_WEB_APP_PROD : BASE_URL_WEB_APP_DEV;
  const fallbackUrl = `${baseUrl}/groups?${fallbackParams.toString()}`;

  return buildAdjustLink({
    path,
    fallbackUrl,
    adjT: GO_LINK_ADJ_T,
  });
};
